document.addEventListener("DOMContentLoaded", function(){
    var intervalFooter = setInterval(() => {
      if (document.querySelector(".newsletterForm .klaviyo-form input[id*='first_name']")) {
        jsFooterForm();
      }
    }, "500")
    function jsFooterForm() {
      clearInterval(intervalFooter);
      var knName = document.querySelector(".footer .newsletterForm .klaviyo-form input[id*='first_name']");
      var knEmail = document.querySelector(".footer .newsletterForm .klaviyo-form input[id*='email']");
      var knLegal = document.querySelectorAll(".footer .klaviyo-form div[data-testid='form-row']:has(.go3431972610)");
      var knButton = document.querySelector(".footer .newsletterForm .klaviyo-form button");
      var knText = document.querySelector(".footer .newsletterForm + .newsletter-info");
      
      knLegal.forEach(function(legal){
        legal.style.setProperty('opacity', '0', 'important');
        legal.style.setProperty('height', '0', 'important');
        legal.style.setProperty('visibility', 'hidden', 'important');
        legal.style.setProperty('overflow', 'hidden', 'important');
        legal.style.setProperty('transition', 'opacity 800ms, height 800ms', 'important');
      });
    
      const onNewsletterFocusk = (event) => {
        knLegal.forEach(function(legal){
          legal.style.setProperty('opacity', '1', 'important');
          legal.style.setProperty('height', 'auto', 'important');
          legal.style.setProperty('visibility', 'visible', 'important');
          legal.style.setProperty('overflow', 'visible', 'important');
          legal.style.setProperty('transition', 'opacity 500ms, height 500ms', 'important');
        });

        knButton.style.setProperty("display", "block", "important");

        knButton.style.setProperty('opacity', '1', 'important');
        knButton.style.setProperty('height', 'auto', 'important');
        knButton.style.setProperty('visibility', 'visible', 'important');
        knButton.style.setProperty('overflow', 'visible', 'important');
        knButton.style.setProperty('transition', 'opacity 500ms, height 500ms', 'important');

        knText.style.setProperty('opacity', '1', 'important');
        knText.style.setProperty('height', 'auto', 'important');
        knText.style.setProperty('visibility', 'visible', 'important');
        knText.style.setProperty('overflow', 'visible', 'important');
        knText.style.setProperty('transition', 'opacity 800ms, height 800ms', 'important');        
      }
    
      if (knName != null && knName != undefined && knEmail != null && knEmail != undefined) {
        knName.addEventListener('focus', onNewsletterFocusk);
        knEmail.addEventListener('focus', onNewsletterFocusk);
      }
    }
});